import React, { useContext, useEffect } from 'react';
import classes from './TypeSampleSourceForm.module.css';
import { sampleUpsert } from '../../../../../services/sample.services';
import {
  createTypeSampleSource,
  updateTypeSampleSource,
} from '../../../../../services/typeSampleSource.services';
import { modeContext } from '../../../../Contexts/contexts';
import { observer } from 'mobx-react-lite';
import { TypeSampleSourceStore } from '../../../../../store/context/TypeSampleSourceStore';
import { UserFields } from './TypeFields/UserFields';
import error from '../../../../../assets/svg/attention-01.svg';
import DefaultFields from './TypeFields/DefaultFields';

const TypeSampleSourceForm = observer(({ mode, id = null }) => {
  const mainContext = React.useContext(modeContext);
  const { setWidget } = mainContext.widget;
  const { typeSampleSourceSelected, setTypeSampleSourceField, clearTypeSampleSourceField } =
    useContext(TypeSampleSourceStore);

  const [isClickAdd, setIsClickAdd] = React.useState(false);
  const [isChange, setIsChange] = React.useState(false);

  useEffect(() => {
    mode.updateMode();
  }, [typeSampleSourceSelected]);

  React.useEffect(() => {
    if (isChange == true)
      setWidget({
        status: 'Ok',
        text:
          typeSampleSourceSelected.id != null
            ? `Тип источника образца успешно изменен!`
            : 'Тип источника образца добавлен успешно!',
        fun: async () => {
          closeTab();
        },
      });
  }, [isChange]);

  const cancelClick = () => {
    closeTab();
  };

  const closeTab = () => {
    clearTypeSampleSourceField();
    let tabs = JSON.parse(JSON.stringify(mode.tabs));
    let activeTab = tabs.find((val) => val.id == mode.activeTabId);
    let index = tabs.indexOf(activeTab);
    tabs.splice(index, 1);

    if (tabs.length > 0) {
      mode.setTabs(tabs);
      mode.setActiveTabId(tabs[tabs.length - 1].id);
      mode.setModeByParseTab(tabs[tabs.length - 1]);
    } else {
      mode.setTabs(tabs);
      mode.setPath('');
      mode.setType({ mode: 'view', item: '' });
      mode.setActiveTabId(0);
    }
  };

  const addClick = () => {
    setIsClickAdd(true);

    if (!typeSampleSourceSelected.name || !typeSampleSourceSelected.description) return;
    if (typeSampleSourceSelected.id != null)
      return setWidget({
        status: 'Attention',
        text: `Данные типа источника будут изменены`,
        fun: async () => {
          save();
        },
      });

    save();
  };

  const save = () => {
    const typeSampleSourceUpsertAsync = async () => {
      let res;
      if (typeSampleSourceSelected.id != null) {
        res = await updateTypeSampleSource(typeSampleSourceSelected.id, {
          ...typeSampleSourceSelected,
        });
      } else res = await createTypeSampleSource({ ...typeSampleSourceSelected });

      if (!res.success) {
        errorHandler(res.error_code);
      } else {
        setIsChange(true);
      }
    };
    typeSampleSourceUpsertAsync();
  };

  const errorHandler = (code) => {
    setWidget({
      status: 'Error',
      text: ` Код № ${code}.`,
      fun: async () => {},
    });
  };

  const setTab = (val) => {
    setTypeSampleSourceField('activeFieldTabId', val);
  };
  //TODO - поправить стили у таб
  {
    /* <div className={classes.sampleTypeContainer}>
        <div className={classes.navSampleType}>
        <div className={classes.navTab}> */
  }

  return (
    <div className={classes.sampleTypeContainer}>
      <div className={classes.navContainer}>
        <div className={classes.navSampleType}>
          <div
            className={
              (typeSampleSourceSelected.activeFieldTabId == 1 ? classes.activeTab : '') +
              ' ' +
              classes.navTab
            }
            onClick={() => setTab(1)}
          >
            Стандартные поля
          </div>

          <div
            className={
              (typeSampleSourceSelected.activeFieldTabId == 2 ? classes.activeTab : '') +
              ' ' +
              classes.navTab
            }
            onClick={() => setTab(2)}
          >
            Пользовательские поля
          </div>
        </div>
      </div>
      <div className={classes.tabsContainer}>
        {typeSampleSourceSelected.activeFieldTabId == 1 && (
          <DefaultFields
            isClickAdd={isClickAdd}
            mode={mode}
            typeSampleSourceSelected={typeSampleSourceSelected}
            setTypeSampleSourceField={setTypeSampleSourceField}
          />
        )}
      </div>
      <div className={classes.tabsContainer}>
        {typeSampleSourceSelected.activeFieldTabId == 2 && (
          <UserFields
            mode={mode}
            setTypeSampleSourceField={setTypeSampleSourceField}
            typeSampleSourceSelected={typeSampleSourceSelected}
          />
        )}
        <div className={classes.footer}>
          {
            <button className={`button_default save_style`} onClick={() => addClick()}>
              {typeSampleSourceSelected.id == null ? 'Добавить' : 'Редактировать'}
            </button>
          }
          <button
            className={`button_default cancel_style`}
            style={{
              marginLeft:
                !typeSampleSourceSelected.editable && typeSampleSourceSelected.editable != null
                  ? '0px'
                  : '20px',
            }}
            onClick={() => cancelClick()}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
});

export default TypeSampleSourceForm;
